export const ADDRESS_POSTCODE_SEGMENT_PATTERN = /^\d{4,5}\b/

export const ADDRESS_SEGMENT_SPLIT_PATTERN = /\s*,\s*/

export const ADDRESS_SEGMENT_SEPARATOR = ', '
